import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { WaitingRoom } from './WaitingRoom';
import { set } from '../../../features/SessionStorageState/services/service';

export const REDIRECT_TO_STORAGE_KEY = 'redirectTo';

function isValidRedirectUrl(url: string): boolean {
	try {
		const { protocol } = new URL(url);
		return protocol === 'https:' || protocol === 'http:';
	} catch {
		return false;
	}
}

export function WaitingRoomFactory() {
	const { code, tenant } = useParams();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const redirectTo = searchParams.get(REDIRECT_TO_STORAGE_KEY);
		if (redirectTo && isValidRedirectUrl(redirectTo)) {
			set(REDIRECT_TO_STORAGE_KEY, redirectTo);
		}
	}, [searchParams]);

	return <WaitingRoom code={code} tenant={tenant} />;
}
